import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDDealer implements ICommand
{

	public DealerID : number = 0;
	public DealerName : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.DealerID = ba.readUint32();
		this.DealerName = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.DealerID);
		ba.writeString(this.DealerName);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDDealer();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'DealerID(D)='+this.DealerID+' ';
		str += 'DealerName(S)='+this.DealerName+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'Dealer';
	}

}
